import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from './Icon';
import { NotificationsButton } from './NotificationsButton';

type TopbarProps = {
  crumbRoot: string;
  crumbCurrent?: string;
  onSearchClick?: () => void;
  right?: ReactNode;
};

/**
 * Top frame above the main content. The breadcrumb + global search box +
 * notifications popover. Clicking the search box opens the command
 * palette (also bound to Cmd/Ctrl+K at the AppShell level).
 */
export function Topbar({ crumbRoot, crumbCurrent, onSearchClick, right }: TopbarProps) {
  const { t } = useTranslation();
  return (
    <header className="topbar">
      <div className="crumbs">
        <span>{crumbRoot}</span>
        {crumbCurrent && (
          <>
            <Icon name="chevright" className="sep" size={14} />
            <span className="cur">{crumbCurrent}</span>
          </>
        )}
      </div>
      <button
        type="button"
        className="search-box"
        onClick={onSearchClick}
        style={{ border: '1px solid var(--line)', cursor: 'pointer' }}
        aria-label={t('topbar.searchPlaceholder') ?? ''}
      >
        <Icon name="search" />
        <span
          style={{
            flex: 1,
            textAlign: 'left',
            fontWeight: 500,
            color: 'var(--ink-4)',
            font: '600 13.5px var(--ff)',
          }}
        >
          {t('topbar.searchPlaceholder')}
        </span>
        <span className="kbd">⌘ K</span>
      </button>
      <div className="tb-right">
        <NotificationsButton />
        {right}
      </div>
    </header>
  );
}
